import { FC, ReactElement, ReactNode } from "react";
import useLoadAfterSetup, {
  type AfterSetupPhase,
} from "./useLoadAfterSetup";

interface ISuspenseAfterSetupProps {
  fallback?: ReactNode;
  children: ReactNode;
  /** @default "initialized" — voir `AfterSetupPhase` */
  phase?: AfterSetupPhase;
}

const SuspenseAfterSetup: FC<ISuspenseAfterSetupProps> = (props) => {
  const { fallback, children, phase } = props;
  const hasSetup = useLoadAfterSetup({ phase });
  return (hasSetup ? children : fallback || null) as ReactElement;
};

export default SuspenseAfterSetup;
